<template>
  <span class="domain-state-chip" :class="[`domain-state-chip--${modifier}`, size === 'sm' ? 'domain-state-chip--sm' : '']">
    <!-- In use: check -->
    <svg v-if="state === 'in_use'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.5l3 3 7-7"/></svg>
    <!-- Parked: clock -->
    <svg v-else-if="state === 'parked'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="9" cy="9" r="6.5"/><path d="M9 5.5V9l2.4 1.5"/></svg>
    <!-- Abandoned: flag -->
    <svg v-else-if="state === 'abandoned'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 15.5V3"/><path d="M4 3h9.5l-2.2 3 2.2 3H4"/></svg>
    <!-- Unknown: question mark, dashed hollow pill (never a filled colour — "we know something" would be false) -->
    <svg v-else viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="9" r="6.5"/><path d="M7 7a2 2 0 1 1 2.8 1.8c-.6.3-1 .7-1 1.5v.3"/><circle cx="9" cy="12.8" r=".3" fill="currentColor" stroke="none"/></svg>
    {{ label }}
  </span>
</template>

<script setup>
// The usage-state chip — one component for every surface so In use / Parked /
// Abandoned / Unknown can never drift in colour or shape between the table,
// the picker and the drawer. "Unknown" is deliberately a dashed hollow pill
// (`fleet-inventory.html`'s established "no data yet" treatment), not a
// colour variant of Parked.
import { computed } from 'vue';
import { stateLabel, stateModifier } from '@root/services/domainFormat';

const props = defineProps({
  state: { type: String, required: true },
  size: { type: String, default: 'md' }, // 'md' | 'sm'
});

const label = computed(() => stateLabel(props.state));
const modifier = computed(() => stateModifier(props.state));
</script>

<style lang="scss">
.domain-state-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  padding: 3.5px 10px;
  border-radius: 12px;
  white-space: nowrap;

  svg {
    width: 11px;
    height: 11px;
  }

  &--sm {
    padding: 2px 8px;
    font-size: 10px;

    svg {
      width: 10px;
      height: 10px;
    }
  }

  &--inuse {
    background: #e1f3ea;
    color: #1c7a4d;
  }

  &--parked {
    background: #ddeaf4;
    color: #215d84;
  }

  &--abandoned {
    background: #fbeeda;
    color: #8a5a0d;
  }

  &--unknown {
    background: transparent;
    border: 1.5px dashed var(--theme-text-tertiary);
    color: var(--theme-text-secondary);
  }
}
</style>
